import React, { useState } from 'react';
import { useMenu, useCategoryMenu, useMenuSearch } from '../../hooks/useMenu';
import { faqs } from '../../data'; // Fallback to static data
import Bredcom from '../Bredcrumb/Main';
import Offer from '../Allmenus/FirstMenu/Offers';
import Reservation from '../Allmenus/FirstMenu/Reservation';
import bgone from '../../assets/images/background/bg-16.png';
import bgtwo from '../../assets/images/background/bg-17.png';
import bgthree from '../../assets/images/background/bg-18.png';
import bg19 from '../../assets/images/background/bg-19.png';
import bg20 from '../../assets/images/background/bg-20.png';

function CMSMenuWithLayout({ 
  categoryFilter = null,
  title = "OUR DELICIOUS MENU",
  subtitle = "Choose Your Favorite",
  bannerImage,
  showOffers = true,
  showReservation = true 
}) {
  const { menu, loading, error } = useMenu();
  const { searchResults, searchMenu, clearSearch, loading: searchLoading } = useMenuSearch();
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedCategory, setSelectedCategory] = useState(categoryFilter || 'all');

  // Fallback to static data if CMS is unavailable
  const isUsingCMS = !error;
  
  // Filter data based on category
  const getFilteredData = () => {
    if (error) {
      // Use static data
      if (categoryFilter) {
        return faqs.filter(item => 
          item.foodCategory.toLowerCase().includes(categoryFilter.toLowerCase())
        );
      }
      return faqs;
    }

    // Use CMS data
    if (categoryFilter) {
      return menu.categories.filter(category => 
        category.slug === categoryFilter || 
        category.name.toLowerCase().includes(categoryFilter.toLowerCase())
      );
    }
    return menu.categories;
  };

  const displayData = getFilteredData();

  const handleSearch = (e) => {
    const query = e.target.value;
    setSearchQuery(query);
    
    if (query.trim()) {
      // If we have a category filter, search within that category
      const categoryId = categoryFilter ? 
        menu.categories.find(cat => cat.slug === categoryFilter)?.id : 
        (selectedCategory === 'all' ? null : selectedCategory);
      searchMenu(query, categoryId);
    } else {
      clearSearch();
    }
  };

  const handleCategoryFilter = (categoryId) => {
    setSelectedCategory(categoryId);
    if (searchQuery.trim()) {
      const catId = categoryId === 'all' ? null : categoryId;
      searchMenu(searchQuery, catId);
    }
  };

  const renderMenuItem = (item) => (
    <div key={item.id || item.name} className="dish-block">
      <div className="inner-box">
        <div className="title clearfix">
          <div className="ttl clearfix">
            <h5>{item.name}</h5>
          </div>
          <div className="price">
            <span>JD{item.price}</span>
          </div>
        </div>
        <div className="text desc">
          {item.description}
        </div>
        {item.allergens && item.allergens.length > 0 && (
          <div className="allergens">
            <small>⚠️ Allergens: {item.allergens.join(', ')}</small>
          </div>
        )}
        {item.preparation_time && (
          <div className="prep-time">
            <small>🕒 Prep time: {item.preparation_time} min</small>
          </div>
        )}
        {!item.is_available && (
          <div className="unavailable">
            <small style={{color: '#dc3545'}}>❌ Currently unavailable</small>
          </div>
        )}
      </div>
    </div>
  );

  const renderCMSCategory = (category, index) => {
    if (!category.items || category.items.length === 0) return null;
    
    const isAlternate = index % 2 === 1;
    
    return (
      <section key={category.id} className={`menu-one ${isAlternate ? 'alternate' : ''}`}>
        {!isAlternate && (
          <div className="right-bg">
            <img src={bgone} alt="" title="" />
          </div>
        )}
        {isAlternate && (
          <>
            <div className="left-bg">
              <img src={bgtwo} alt="" title="" />
            </div>
            <div className="right-bg-2">
              <img src={bgthree} alt="" title="" />
            </div>
          </>
        )}
        <div className="auto-container">
          <div className="title-box centered">
            <div className="subtitle">
              <span>{category.name}</span>
            </div>
            <div className="pattern-image">
              <img
                src={require('../../assets/images/icons/separator.svg').default}
                alt="separator"
              />
            </div>
            <h2>{category.description || 'Delicious Selections'}</h2>
          </div>
          
          <div className="row clearfix">
            <div className="menu-col col-lg-6 col-md-12 col-sm-12">
              <div className="inner">
                {category.items.slice(0, Math.ceil(category.items.length / 2)).map(renderMenuItem)}
              </div>
            </div>
            <div className="menu-col col-lg-6 col-md-12 col-sm-12">
              <div className="inner">
                {category.items.slice(Math.ceil(category.items.length / 2)).map(renderMenuItem)}
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  };

  const renderStaticCategory = (categoryData, index) => {
    const isAlternate = index % 2 === 1;
    
    return (
      <section key={categoryData.foodCategory} className={`menu-one ${isAlternate ? 'alternate' : ''}`}>
        {!isAlternate && (
          <div className="right-bg">
            <img src={bgone} alt="" title="" />
          </div>
        )}
        {isAlternate && (
          <>
            <div className="left-bg">
              <img src={bgtwo} alt="" title="" />
            </div>
            <div className="right-bg-2">
              <img src={bgthree} alt="" title="" />
            </div>
          </>
        )}
        <div className="auto-container">
          <div className="title-box centered">
            <div className="subtitle">
              <span>{categoryData.foodCategory}</span>
            </div>
            <div className="pattern-image">
              <img
                src={require('../../assets/images/icons/separator.svg').default}
                alt="separator"
              />
            </div>
            <h2>Delicious Selections</h2>
          </div>
          {categoryData.foodItem}
        </div>
      </section>
    );
  };

  if (loading) {
    return (
      <>
        {bannerImage && (
          <Bredcom subtitle={subtitle} title={title} Img={bannerImage} />
        )}
        <section className="menu-one">
          <div className="right-bg">
            <img src={bgone} alt="" title="" />
          </div>
          <div className="auto-container">
            <div className="title-box centered">
              <div className="subtitle">
                <span>please wait</span>
              </div>
              <div className="pattern-image">
                <img
                  src={require('../../assets/images/icons/separator.svg').default}
                  alt="separator"
                />
              </div>
              <h2>Loading Delicious Menu...</h2>
            </div>
            <div className="loading-state text-center" style={{padding: '40px 0'}}>
              <div className="spinner-border text-primary" role="status" style={{color: '#c9302c !important'}}>
                <span className="sr-only">Loading...</span>
              </div>
              <p style={{marginTop: '20px', color: '#666'}}>Preparing our finest dishes for you</p>
            </div>
          </div>
        </section>
      </>
    );
  }

  return (
    <>
      {/* Breadcrumb */}
      {bannerImage && (
        <Bredcom subtitle={subtitle} title={title} Img={bannerImage} />
      )}

      {/* Menu Controls */}
      {isUsingCMS && (
        <section className="menu-controls" style={{padding: '60px 0 40px', backgroundColor: '#f8f8f8'}}>
          <div className="auto-container">
            <div className="row">
              <div className="col-lg-8 col-md-12">
                <div className="cms-status" style={{marginBottom: '20px'}}>
                  <span className="badge badge-success">🔴 Live Menu from CMS</span>
                  <span style={{marginLeft: '10px', color: '#666'}}>
                    {menu.totalCategories} categories • {menu.totalItems} items
                  </span>
                </div>
              </div>
              <div className="col-lg-4 col-md-12">
                <div className="search-box" style={{marginBottom: '20px'}}>
                  <input
                    type="text"
                    placeholder="Search menu items..."
                    value={searchQuery}
                    onChange={handleSearch}
                    className="form-control"
                    style={{borderRadius: '25px', border: '2px solid #c9302c'}}
                  />
                </div>
              </div>
            </div>

            {!categoryFilter && (
              <div className="category-filter text-center" style={{marginBottom: '20px'}}>
                <select 
                  value={selectedCategory} 
                  onChange={(e) => handleCategoryFilter(e.target.value)}
                  className="form-control"
                  style={{display: 'inline-block', width: 'auto', minWidth: '200px', borderRadius: '25px', border: '2px solid #c9302c'}}
                >
                  <option value="all">All Categories</option>
                  {menu.categories.map(category => (
                    <option key={category.id} value={category.id}>
                      {category.name} ({category.items?.length || 0})
                    </option>
                  ))}
                </select>
              </div>
            )}
          </div>
        </section>
      )}

      {!isUsingCMS && (
        <section className="menu-controls" style={{padding: '40px 0', backgroundColor: '#f8f8f8', textAlign: 'center'}}>
          <div className="auto-container">
            <span className="badge badge-warning">⚠️ Using Static Menu (CMS Offline)</span>
          </div>
        </section>
      )}

      {/* Search Results */}
      {searchQuery && searchResults.items.length > 0 && (
        <section className="menu-one">
          <div className="right-bg">
            <img src={bg19} alt="" title="" />
          </div>
          <div className="auto-container">
            <div className="title-box centered">
              <div className="subtitle">
                <span>Search Results</span>
              </div>
              <div className="pattern-image">
                <img
                  src={require('../../assets/images/icons/separator.svg').default}
                  alt="separator"
                />
              </div>
              <h2>Found {searchResults.count} items for "{searchQuery}"</h2>
            </div>
            <div className="row clearfix">
              <div className="menu-col col-lg-6 col-md-12 col-sm-12">
                <div className="inner">
                  {searchResults.items.slice(0, Math.ceil(searchResults.items.length / 2)).map(renderMenuItem)}
                </div>
              </div>
              <div className="menu-col col-lg-6 col-md-12 col-sm-12">
                <div className="inner">
                  {searchResults.items.slice(Math.ceil(searchResults.items.length / 2)).map(renderMenuItem)}
                </div>
              </div>
            </div>
          </div>
        </section>
      )}

      {/* No search results */}
      {searchQuery && searchResults.items.length === 0 && !searchLoading && (
        <section className="menu-one">
          <div className="auto-container">
            <div className="title-box centered">
              <div className="subtitle">
                <span>No Results</span>
              </div>
              <div className="pattern-image">
                <img
                  src={require('../../assets/images/icons/separator.svg').default}
                  alt="separator"
                />
              </div>
              <h2>No items found for "{searchQuery}"</h2>
              <div className="text">Try a different search term or browse our categories above.</div>
            </div>
          </div>
        </section>
      )}

      {/* Menu Display */}
      {!searchQuery && (
        <>
          {isUsingCMS ? 
            displayData.map((category, index) => renderCMSCategory(category, index)) : 
            displayData.map((categoryData, index) => renderStaticCategory(categoryData, index))
          }
        </>
      )}

      {/* Offers Section */}
      {showOffers && <Offer />}

      {/* Reservation Section */}
      {showReservation && <Reservation />}

      <style jsx>{`
        .cms-status .badge {
          font-size: 0.9em;
          padding: 8px 12px;
          border-radius: 20px;
        }
        
        .badge-success {
          background-color: #28a745;
          color: white;
        }
        
        .badge-warning {
          background-color: #ffc107;
          color: #212529;
        }
        
        .allergens, .prep-time {
          margin-top: 8px;
          color: #666;
          font-size: 0.85em;
        }
        
        .unavailable {
          margin-top: 8px;
        }
        
        .search-box input:focus,
        .category-filter select:focus {
          border-color: #c9302c !important;
          box-shadow: 0 0 0 0.2rem rgba(201, 48, 44, 0.25) !important;
          outline: none;
        }
        
        .menu-controls {
          border-bottom: 1px solid #eee;
        }
        
        .form-control {
          transition: all 0.3s ease;
        }
        
        .form-control:hover {
          border-color: #c9302c;
        }
      `}</style>
    </>
  );
}

export default CMSMenuWithLayout;